// Capabilities that are available in native app
enum NativeCapability {}

export default NativeCapability;
